import { useCallback, useMemo } from 'react';
import type { PickingInfo } from 'deck.gl';

export function useSewerAnalysisMode(params: { enabled: boolean }) {
	const { enabled } = params;

	const layers = useMemo(() => [], []);
	const panelElement = null;

	const onMapClick = useCallback((_info: PickingInfo) => {
		if (!enabled) return false;
		return false;
	}, [enabled]);

	return {
		layers,
		panelElement,
		onMapClick,
	};
}

export default useSewerAnalysisMode;
